import { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import { ContactModal } from '@/components/contact';

export default function AuthLayout() {
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex justify-center items-center">
          <svg
            className="h-12 w-12"
            viewBox="0 0 100 100"
            aria-label="FlowIO Logo"
          >
            <defs>
              <linearGradient id="auth-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" style={{ stopColor: '#0ea5e9' }} />
                <stop offset="100%" style={{ stopColor: '#8b5cf6' }} />
              </linearGradient>
            </defs>
            <path
              d="M20 30 Q50 30 50 50 T80 70"
              stroke="url(#auth-gradient)"
              strokeWidth="8"
              fill="none"
              strokeLinecap="round"
              opacity="0.8"
            />
            <path
              d="M20 50 Q50 50 80 50"
              stroke="url(#auth-gradient)"
              strokeWidth="12"
              fill="none"
              strokeLinecap="round"
            />
            <path
              d="M20 70 Q50 70 50 50 T80 30"
              stroke="url(#auth-gradient)"
              strokeWidth="6"
              fill="none"
              strokeLinecap="round"
              opacity="0.6"
            />
            <circle cx="20" cy="50" r="8" fill="#0ea5e9" />
            <circle cx="80" cy="50" r="8" fill="#8b5cf6" />
          </svg>
          <span className="ml-3 text-2xl font-bold text-gray-900">FlowIO</span>
        </Link>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-xl sm:px-10 border border-gray-200">
          <Outlet />
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-8 text-center text-sm text-gray-500">
        <div className="flex justify-center gap-3 flex-wrap">
          <Link to="/terms" className="hover:text-gray-700">Terms</Link>
          <span>·</span>
          <Link to="/privacy" className="hover:text-gray-700">Privacy</Link>
          <span>·</span>
          <Link to="/security" className="hover:text-gray-700">Security</Link>
          <span>·</span>
          <Link to="/about" className="hover:text-gray-700">About</Link>
          <span>·</span>
          <button
            type="button"
            onClick={() => setContactOpen(true)}
            className="hover:text-gray-700"
          >
            Contact
          </button>
        </div>
        <p className="mt-2">{new Date().getFullYear()} FlowIO</p>
      </footer>

      <ContactModal isOpen={contactOpen} onClose={() => setContactOpen(false)} />
    </div>
  );
}
